import React, { useEffect, useState } from "react";
import Footerdeo from "../shared/Footerdeo";
import Navbardeo from "../shared/Navbardeo";
import Sidebardeo from "../shared/Sidebardeo";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import config from "../../config";
import {
  MdOutlineKeyboardArrowLeft,
  MdOutlineKeyboardArrowRight,
  MdOutlineKeyboardDoubleArrowLeft,
  MdOutlineKeyboardDoubleArrowRight,
} from "react-icons/md";

function Pendingforapproval() {
  const navigate = useNavigate();
  const [pendingSchools, setPendingSchools] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(100);
  const [searchQuery, setSearchQuery] = useState("");

  // Filter schools by search query
  const filteredSchools = pendingSchools.filter((school) => {
    const query = searchQuery.toLowerCase();
    return (
      school.schooL_NAME?.toLowerCase().includes(query) ||
      school.schooL_CODE?.toLowerCase().includes(query) ||
      school.piN_CODE?.toLowerCase().includes(query) ||
      school.posT_OFFICE?.toLowerCase().includes(query)
    );
  });

  const totalPages = Math.ceil(filteredSchools.length / perPage);
  const indexOfLastItem = currentPage * perPage;
  const indexOfFirstItem = indexOfLastItem - perPage;
  const currentItems = filteredSchools.slice(indexOfFirstItem, indexOfLastItem);

  const handlePerPageChange = (e) => {
    setPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  useEffect(() => {
    const fetchPendingData = async () => {
      setLoading(true);

      try {
        const response = await axios.post(
          `${config.API_BASE_URL}/FetchDEOPendingSchools_CL9`,
          {
            deO_ID: sessionStorage.getItem("deoId"),
          },
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("deotoken")}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data.status === 200) {
          setPendingSchools(response.data.data.deoPending_status || []);
        } else {
          console.error("Unexpected response status:", response.data);
        }
      } catch (error) {
        console.error("Error fetching pending data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPendingData();
  }, []);

  return (
    <div className="container-scroller">
      <Navbardeo />
      {loading && (
        <div className="custom-loader-container">
          <div className="custom-loader"></div>
        </div>
      )}
      <div className="container-fluid page-body-wrapper">
        <Sidebardeo />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="row">
              <div className="col-md-12 mb-3">
                <section className="content-header">
                  <h1>
                    <i className="fa fa-user"></i>&nbsp; Pending List Of Schools
                  </h1>
                  <ol className="breadcrumb">
                    <li>
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate("/deo-dashboard");
                        }}
                      >
                        <i className="fa fa-home"></i> Home&nbsp;
                      </a>
                    </li>
                    <li className="active">Pending List Of Schools</li>
                  </ol>
                </section>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <div className="d-flex align-items-center">
                        <label htmlFor="rowsPerPage" className="me-2 mb-0">
                          Rows:
                        </label>
                        <select
                          id="rowsPerPage"
                          className="form-select form-select-sm"
                          value={perPage}
                          onChange={handlePerPageChange}
                          style={{ width: "80px" }}
                        >
                          {[10, 20, 50, 100, 500].map((num) => (
                            <option key={num} value={num}>
                              {num}
                            </option>
                          ))}
                        </select>
                      </div>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="Search..."
                        style={{ width: "200px" }}
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                      />
                    </div>

                    <table className="table table-condensed table-striped table-bordered">
                      <thead>
                        <tr>
                          <th>Sl No.</th>
                          <th>School Code</th>
                          <th>School Name</th>
                          <th>Pin Code</th>
                          <th>Post Office</th>
                          <th>No. of Students</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentItems.length === 0 ? (
                          <tr>
                            <td colSpan="7" className="text-center">
                              No schools found.
                            </td>
                          </tr>
                        ) : (
                          currentItems.map((school, index) => (
                            <tr key={index}>
                              <td>{indexOfFirstItem + index + 1}</td>
                              <td>{school.schooL_CODE}</td>
                              <td>{school.schooL_NAME}</td>
                              <td>{school.piN_CODE}</td>
                              <td>{school.posT_OFFICE || "N/A"}</td>
                              <td>{school.nO_OF_STUDENT}</td>
                              <td>
                                <button
                                  className="btn btn-sm btn-success"
                                  onClick={() =>
                                    navigate("/total-pending-applicant", {
                                      state: { school },
                                    })
                                  }
                                >
                                  <i
                                    className="fa fa-angle-double-right"
                                    aria-hidden="true"
                                  ></i>
                                  &nbsp; Initiate Approval
                                </button>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>

                    <div className="d-flex justify-content-between align-items-center mt-3">
                      <div>
                        Showing{" "}
                        {filteredSchools.length === 0
                          ? 0
                          : indexOfFirstItem + 1}{" "}
                        to {Math.min(indexOfLastItem, filteredSchools.length)}{" "}
                        of {filteredSchools.length} entries
                      </div>
                      <div className="d-flex align-items-center gap-2">
                        <MdOutlineKeyboardDoubleArrowLeft
                          onClick={() => currentPage > 1 && setCurrentPage(1)}
                          style={{
                            cursor: currentPage > 1 ? "pointer" : "not-allowed",
                            opacity: currentPage > 1 ? 1 : 0.5,
                          }}
                        />
                        <MdOutlineKeyboardArrowLeft
                          onClick={() =>
                            currentPage > 1 &&
                            setCurrentPage((prev) => prev - 1)
                          }
                          style={{
                            cursor: currentPage > 1 ? "pointer" : "not-allowed",
                            opacity: currentPage > 1 ? 1 : 0.5,
                          }}
                        />
                        <span>
                          Page {currentPage} of {totalPages}
                        </span>
                        <MdOutlineKeyboardArrowRight
                          onClick={() =>
                            currentPage < totalPages &&
                            setCurrentPage((prev) => prev + 1)
                          }
                          style={{
                            cursor:
                              currentPage < totalPages
                                ? "pointer"
                                : "not-allowed",
                            opacity: currentPage < totalPages ? 1 : 0.5,
                          }}
                        />
                        <MdOutlineKeyboardDoubleArrowRight
                          onClick={() =>
                            currentPage < totalPages &&
                            setCurrentPage(totalPages)
                          }
                          style={{
                            cursor:
                              currentPage < totalPages
                                ? "pointer"
                                : "not-allowed",
                            opacity: currentPage < totalPages ? 1 : 0.5,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footerdeo />
        </div>
      </div>
    </div>
  );
}

export default Pendingforapproval;
